<nav class="navbar navbar-expand-lg bg-white border-bottom">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <span class="icon icon24 logo mr-1"></span>
      <span translate>app.top.menu.invest</span>
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
            aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLink="/"></a>
        </li>
        <li class="nav-item" *ngIf="apiService.isAuthorized()">
          <a class="nav-link" routerLink="/deals" translate>app.top.menu.deals</a>
        </li>
        <li class="nav-item" *ngIf="apiService.hasRole('admin')">
          <a class="nav-link" routerLink="/tokens" translate>app.top.menu.tokens</a>
        </li>
      </ul>
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li *ngIf="apiService.isAuthorized()">
          <div class="dropdown">
            <a href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <span class="icon icon24 notification mx-2"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" style="font-size: 12px; width: 400px">
              <li *ngFor="let n of notificationService.getNotifications()">
                <span class="fw-bold">{{ n.title }}</span>
                <p>{{ n.message }}</p>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item px-2">
          <div class="dropdown">
            <a href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Language</a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li *ngFor="let language of languageService.getLanguages()">
                <a (click)="switchLang(language)">{{ languageService.displayLanguage(language) }}</a>
              </li>
            </ul>
          </div>
        </li>
        <li *ngIf="apiService.isAnonymous()" class="nav-item">
          <a class="nav-link" routerLink="/sign-up" translate>app.top.menu.register</a>
        </li>
        <li *ngIf="apiService.isAnonymous()" class="nav-item">
          <a class="nav-link" routerLink="/sign-in" translate>app.top.menu.login</a>
        </li>

        <li *ngIf="apiService.isAuthorized()" class="nav-item">
          <div class="dropdown">
            <a href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ userService.getCurrentUser().displayName }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a class="dropdown-item" routerLink="/profile" translate>app.top.menu.profile</a>
              </li>
              <li>
                <hr class="dropdown-divider"/>
              </li>
              <li>
                <a class="dropdown-item" (click)="apiService.signOut()" translate>app.top.menu.logout</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
